import { render, staticRenderFns } from "./addCustomer.vue?vue&type=template&id=ec7520b2"
import script from "./addCustomer.vue?vue&type=script&lang=js"
export * from "./addCustomer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports